<template>
  <div>
    <template v-for="(v, vind) in validationIds">
      <div class="validation-error"
           v-if="errors[v]"
           :key="`val-id-${vind}`">
        <template v-if="Array.isArray(errors[v])">
          <div v-for="(err, eind) in errors[v]" :key="`err-${vind}-${eind}`">
            {{ err }}
          </div>
        </template>
        <template v-else>{{ errors[v] }}</template>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  validationId: {},
})

const store = useStore()

const errors = computed(() => store.state.datatable.validationErrors)
const validationIds = computed(() => {
  if(!props.validationId) return []
  return Array.isArray(props.validationId) ? props.validationId : [props.validationId]
})
</script>
